import { View } from 'react-native';
import { CurvedArrow } from './CurvedArrow';
import { OverlayWithHoles } from './OverlayWithHoles';
import { TutorialCard } from './TutorialCard';
import { useTutorialLogic } from './Tutorial.logic';
import { style } from './Tutorial.style';
import { ITutorial } from './Tutorial.types';
import { observer } from 'mobx-react-lite';
import { useResize } from './useResize';

export const Tutorial = observer(({ overlayColor = 'black', overlayOpacity = 0.3 }: ITutorial) => {
  const props = useTutorialLogic();

  useResize(props);

  if (!props) return <></>;

  return (
    <>
      {props.isTutorialOn && <View style={style.overlay} testID="OVERLAY" />}
      {props.tutorialVisible && (
        <View style={style.wrapper} testID="TUTORIAL">
          {props.withBackground && (
            <OverlayWithHoles holes={[props.targetArea]} opacity={overlayOpacity} color={overlayColor} />
          )}

          <View style={style.arrow}>
            <CurvedArrow
              startX={props.arrowStartX}
              startY={props.arrowStartY}
              endX={props.arrowEndX}
              endY={props.arrowEndY}
              strokeColor={props.arrow.strokeColor}
              curvature={props.arrow.curvature}
              strokeWidth={props.arrow.strokeWidth}
              arrowSize={props.arrow.arrowSize}
            />
          </View>
          <View style={style.card}>
            <TutorialCard
              illustration={props.tutorialCard.illustration}
              text={props.tutorialCard.text}
              ctaText={props.tutorialCard.ctaText}
              x={props.tutorialCard.x}
              y={props.tutorialCard.y}
              onPress={props.goToNextStep}
              withDot={props.tutorialCard.withDot}
              backgroundColor={props.tutorialCard.backgroundColor}
            />
          </View>
        </View>
      )}
    </>
  );
});
